import React from "react";

const CardPanel = ({ children, maxWidth, className = "" }) => {
  const style = maxWidth ? { maxWidth } : undefined;

  return (
    <section className={`ui-card-panel ${className}`.trim()} style={style}>
      {children}
    </section>
  );
};

export default CardPanel;
